import {Component, inject, OnInit, Signal} from '@angular/core'
import {FooterComponent} from '../shared/components/footer/footer.component'
import {MatCard} from '@angular/material/card'
import {MatButton} from '@angular/material/button'
import {RouterLink, RouterOutlet} from '@angular/router'
import {MatToolbar, MatToolbarRow} from '@angular/material/toolbar'
import {NavbarComponent} from '../shared/components/navbar/navbar.component'
import {FullscreenLoaderComponent} from '../shared/components/fullscreen-loader/fullscreen-loader.component'
import {FullscreenLoaderService} from '../shared/components/fullscreen-loader/fullscreen-loader.service'

@Component({
    selector: 'app-auth',
    templateUrl: './auth.component.html',
    styleUrls: ['./auth.component.scss'],
    standalone: true,
    imports: [MatToolbar, MatToolbarRow, RouterLink, MatButton, MatCard, RouterOutlet, FooterComponent, NavbarComponent, FullscreenLoaderComponent]
})
export class AuthComponent implements OnInit {
    private fullscreenLoaderService = inject(FullscreenLoaderService)
    loaderState: Signal<boolean>

    ngOnInit() {
        this.loaderState = this.fullscreenLoaderService.getState()
    }
}
